import { render, staticRenderFns } from "./timeout.vue?vue&type=template&id=52390280&scoped=true&"
import script from "./timeout.vue?vue&type=script&lang=js&"
export * from "./timeout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52390280",
  null
  
)

export default component.exports